import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { P3 } from '../Typo';

const Component = styled(Link)`
  display: flex;
  width: fit-content;
  ${P3};
  :hover {
    color: white;
  }
`;

interface DefaultLinkProps {
  to: string;
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const DefaultLink = ({ to, children, onClick }: DefaultLinkProps) => {
  return (
    <Component to={to} onClick={onClick}>
      {children}
    </Component>
  );
};

export default DefaultLink;
